import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  input: {
    textOverflow: 'ellipsis',
  },
  margin: {
    margin: theme.spacing(1),
  },
  attribute: {
    minWidth: theme.spacing(35),
    paddingRight: theme.spacing(3),
    fontWeight: 'bold',
    fontSize: 14,
  },
  titleTypography: {
    fontWeight: 'bold',
    marginRight: 4,
    flex: 1,
  },
  sectionTitleTypography: {
    fontWeight: 'bold',
    marginBottom: 10,
  },
  valueField: {
    flex: 1,
  },
  assetValue: {
    textDecoration: 'underline',
    color: 'blue',
    cursor: 'pointer',
  },
  checkboxStyle: {
  width: "13px !important",
  height: "14px !important",
},
}));

export default useStyles;
